import { render, staticRenderFns } from "./DetailsCard.vue?vue&type=template&id=dab735ca&scoped=true&"
import script from "./DetailsCard.vue?vue&type=script&lang=js&"
export * from "./DetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCard.vue?vue&type=style&index=0&id=dab735ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab735ca",
  null
  
)

export default component.exports